export const isCSSVar = (name) => name.startsWith("--");
//# sourceMappingURL=is-css-var.js.map